module.exports = "<div id=BP_Loading class=ui-loading-wrap v-show=show><p class=mask><span></span></p></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading.vue
 ** module id = 129
 ** module chunks = 1
 **/